<template>
   <ForgotPasswordDetail />
</template>

<script>
import ForgotPasswordDetail from "@/esf_antarctica_lederhosenland/core/components/authentication/forgot-password/ForgotPasswordDetail.vue"
export default {
  name: "Forgot Password Detail",
  components: {
  ForgotPasswordDetail
  },
  
};
</script>

